/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable react/no-danger */
import React, { FC, useEffect } from 'react'
import { useRouter } from 'next/router'
import { TemporarilyUnavailablePageView } from '@views/error-page/@x/tsp-page'
import { TspPaymentStep } from '@entities/payment'
import { CommissionDataByServiceIdType, DenominationAmountByServiceIdType } from '@entities/denomination'
import { TspPageDenomination, TspPagePayee, useCyberStore } from '@entities/tsp'
import { ServerOption } from '@entities/server'
import { FetchHintsResponseType } from '@entities/hint'
import { useFromOtp } from '../lib/useFromOtp'
import UnreleasedServicePageView from './UnreleasedServicePageView'
import TspFormPageView from './TspFormPageView'
import OtpPcekPageView from './OtpPcekPageView'

interface TspPageViewProps {
  h1: string
  payee: TspPagePayee
  countryVouchers: { country: string; icon: string }[]
  denominationsByCountry: Record<string, TspPageDenomination[]>
  pricesByServiceId: DenominationAmountByServiceIdType
  servers: ServerOption[]
  hints: FetchHintsResponseType
  commissionData: CommissionDataByServiceIdType
}

const TspPageView: FC<TspPageViewProps> = ({
  h1,
  payee,
  countryVouchers,
  denominationsByCountry,
  pricesByServiceId,
  servers,
  hints,
  commissionData,
}) => {
  const { setIsPromocodeActivated, step, setStep } = useCyberStore()
  const router = useRouter()

  // console.log(payee)
  // console.log(denominationsByCountry)

  useFromOtp()

  // useDidMount(() => {
  //   servicesLoadedCyberGtm(payee?.providerName)
  // })

  // useEffect(() => {
  //   const id = setTimeout(() => {
  //     setStep(TspPaymentStep.PAYMENT_OTP)
  //   }, 5000)

  //   return () => {
  //     clearTimeout(id)
  //   }
  // }, [])

  useEffect(() => {
    if (router.query?.id !== 'steam') {
      setIsPromocodeActivated(false)
    }
  }, [router.query?.id])

  if (payee.customParams?.isDisabled) {
    return <UnreleasedServicePageView />
  }

  return {
    [TspPaymentStep.SERVICES_FORM]: (
      <TspFormPageView
        payee={payee}
        h1={h1}
        countryVouchers={countryVouchers}
        denominationsByCountry={denominationsByCountry}
        pricesByServiceId={pricesByServiceId}
        servers={servers}
        hints={hints}
        commissionData={commissionData}
      />
    ),
    [TspPaymentStep.NOT_TCP]: <TemporarilyUnavailablePageView />,
    [TspPaymentStep.PAYMENT_OTP]: <OtpPcekPageView showVouchersForm payee={payee} />,
  }[step]
}

export default TspPageView
